var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { PeriodicalDepositStatusEnum } from "../types/Api";
export var VOLUME_STATUS = {
    CREATED: "pending",
    OVERDUE: "missing",
    RECEIVED: "received",
    RECEIVED_AFTER_ENFORCEMENT: "received",
    EXCLUDED: "excluded",
    DAMAGED: "defective",
    DAMAGED_REPORTED: "defective",
    REQUESTED: "requested",
};
export var VOLUME_TO_ENFORCEMENT_TYPE = {
    urged: "URGENCE",
    reminded: "REMINDER",
    preLitigation: "PRE_LITIGATION_NOTICE",
};
export var VOLUME_COLORS = {
    pending: { bg: "#fff9c4", color: "#f57f17", border: "#f57f17" },
    missing: { bg: "#f8d7da", color: "#721c24", border: "#dc3545" },
    partial: { bg: "#e0f2f1", color: "#00695c", border: "#26a69a" },
    received: { bg: "#d4edda", color: "#155724", border: "#28a745" },
    excluded: { bg: "#e2e3e5", color: "#383d41", border: "#6c757d" },
    defective: { bg: "#fff3cd", color: "#856404", border: "#ffc107" },
    urged: { bg: "#ffe0b2", color: "#bf360c", border: "#e65100" },
    reminded: { bg: "#fff3e0", color: "#e65100", border: "#fb8c00" },
    preLitigation: { bg: "#a71d2a", color: "#ffffff", border: "#7a121c" },
    requested: { bg: "#e3f2fd", color: "#1565c0", border: "#2196f3" },
    na: { bg: "#f0f0f0", color: "#999", border: "#ccc" },
};
export var VOLUME_LABEL_IDS = {
    pending: "ui-br-legaldeposits.detail.volume.pending",
    missing: "ui-br-legaldeposits.detail.volume.missing",
    partial: "ui-br-legaldeposits.detail.volume.partial",
    received: "ui-br-legaldeposits.detail.volume.received",
    excluded: "ui-br-legaldeposits.detail.volume.excluded",
    defective: "ui-br-legaldeposits.detail.volume.defective",
    urged: "ui-br-legaldeposits.detail.volume.urged",
    reminded: "ui-br-legaldeposits.detail.volume.reminded",
    preLitigation: "ui-br-legaldeposits.detail.volume.preLitigation",
    requested: "ui-br-legaldeposits.detail.volume.requested",
    na: "ui-br-legaldeposits.detail.volume.notApplicable",
};
export var DEFAULT_VOLUME_STATUSES = [
    "pending",
    "missing",
    "partial",
    "received",
    "excluded",
    "defective",
    "urged",
    "reminded",
    "preLitigation",
    "requested",
];
export var RAW_STATUS_TO_VOLUME = __assign(__assign({}, VOLUME_STATUS), { URGED: "urged", REMINDED: "reminded", PRE_LITIGATION: "preLitigation" });
var COMMUNICATION_ESCALATION = [
    "reminded",
    "urged",
    "preLitigation",
];
var SUBSTANTIVE_ORDER = [
    "pending",
    "missing",
    "partial",
    "received",
    "excluded",
    "defective",
    "requested",
];
export var VOLUME_OUTLINE_TEXT = {
    // preLitigation is the only status whose fill uses white text, unreadable on an outline badge
    preLitigation: VOLUME_COLORS.preLitigation.border,
};
export var isCommunicationStatus = function (status) {
    return COMMUNICATION_ESCALATION.includes(status);
};
var collapseCommunicationChain = function (statuses) {
    var collapsed = new Set(statuses);
    var present = COMMUNICATION_ESCALATION.filter(function (status) {
        return collapsed.has(status);
    });
    present.slice(0, -1).forEach(function (status) { return collapsed.delete(status); });
    return collapsed;
};
var derivePartial = function (statuses) {
    if (!statuses.has("received") || !statuses.has("missing")) {
        return statuses;
    }
    var derived = new Set(statuses);
    derived.delete("received");
    derived.delete("missing");
    derived.add("partial");
    return derived;
};
export var collapseStatusesPerRecord = function (statusesPerRecord) {
    var aggregated = new Set();
    statusesPerRecord.forEach(function (recordStatuses) {
        var mapped = new Set(recordStatuses.map(function (status) { var _a; return (_a = RAW_STATUS_TO_VOLUME[status]) !== null && _a !== void 0 ? _a : "missing"; }));
        collapseCommunicationChain(mapped).forEach(function (status) {
            return aggregated.add(status);
        });
    });
    var withPartial = derivePartial(aggregated);
    return __spreadArray(__spreadArray([], SUBSTANTIVE_ORDER.filter(function (status) { return withPartial.has(status); }), true), COMMUNICATION_ESCALATION.filter(function (status) { return withPartial.has(status); }), true);
};
var PERIODICAL_SUBSTANTIVE_STATUS = {
    pending: PeriodicalDepositStatusEnum.PENDING,
    missing: PeriodicalDepositStatusEnum.MISSING,
    partial: PeriodicalDepositStatusEnum.PARTIAL,
    received: PeriodicalDepositStatusEnum.RECEIVED,
    excluded: PeriodicalDepositStatusEnum.EXCLUDED,
    defective: PeriodicalDepositStatusEnum.DAMAGED,
    requested: PeriodicalDepositStatusEnum.REQUESTED,
};
export var expandEnforcementTypes = function (volumeStatuses) {
    return volumeStatuses
        .map(function (vs) {
        return VOLUME_TO_ENFORCEMENT_TYPE[vs];
    })
        .filter(function (t) { return t !== undefined; });
};
export var periodicalStatusParams = function (statuses) { return ({
    depositStatuses: statuses
        .map(function (status) {
        return PERIODICAL_SUBSTANTIVE_STATUS[status];
    })
        .filter(function (status) { return !!status; }),
    enforcementTypes: expandEnforcementTypes(statuses),
}); };
// bookmarked URLs from before #75225 carry the old periodical deposit status enum in `depositStatuses`
var LEGACY_PERIODICAL_URL_STATUS = {
    MISSING: "missing",
    URGED: "urged",
    REMINDED: "reminded",
    RECEIVED: "received",
    PENDING: "pending",
    EXCLUDED: "excluded",
    REQUESTED: "requested",
    DAMAGED: "defective",
};
export var parsePeriodicalStatusesFromUrl = function (params) {
    var requested = new Set(__spreadArray(__spreadArray([], params.getAll("statuses"), true), params
        .getAll("depositStatuses")
        .map(function (status) { return LEGACY_PERIODICAL_URL_STATUS[status]; }), true));
    return DEFAULT_VOLUME_STATUSES.filter(function (status) { return requested.has(status); });
};
